export default {
  widgetsPermissions:JSON.parse(localStorage.getItem("widgetsPermission")),
  screensPermissions:JSON.parse(localStorage.getItem("screensPermission"))
}